import { Entity } from '@toggle/toggle';
import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { CompetitorsKnowledgeGraph } from '~/modules/overview-knowledge-graph/components/competitors-knowledge-graph/CompetitorsKnowledgeGraph';
import { GeographicExposureKnowledgeGraph } from '~/modules/overview-knowledge-graph/components/geographic-exposure-knowledge-graph/GeographicExposureKnowledgeGraph';
import { ThemeKnowledgeGraph } from '~/modules/overview-knowledge-graph/components/theme-knowledge-graph/ThemeKnowledgeGraph';

import { RankingMethodologySection } from '../theme-exposure-tab/theme-exposure-table/ranking-methodology-section/RankingMethodologySection';
import * as S from './OverviewTab.styles';

export interface OverviewTabProps {
  entity: Entity;
}

export const OverviewTab = ({ entity }: OverviewTabProps) => {
  return (
    <div>
      <S.GridContainer>
        <ErrorBoundaryWrapper>
          <S.StyledThemeKnowledgeGraph>
            <ThemeKnowledgeGraph entityTag={entity.tag} isInDrawer={false} />
          </S.StyledThemeKnowledgeGraph>
        </ErrorBoundaryWrapper>
        <ErrorBoundaryWrapper>
          <S.StyledCompetitorsKnowledgeGraph>
            <CompetitorsKnowledgeGraph
              entityTag={entity.tag}
              isInDrawer={false}
            />
          </S.StyledCompetitorsKnowledgeGraph>
        </ErrorBoundaryWrapper>
        <ErrorBoundaryWrapper>
          <S.StyledGeographicExposureKnowledgeGraph>
            <GeographicExposureKnowledgeGraph entity={entity} />
          </S.StyledGeographicExposureKnowledgeGraph>
        </ErrorBoundaryWrapper>
      </S.GridContainer>
      <RankingMethodologySection rankingType={'companyToTheme'} />
    </div>
  );
};
